// This file centralizes feature flags that can be toggled based on various conditions.
// import { User } from "~components";
import { BUILD_PROFILE } from "./build";

// Example: Toggle a feature off only in production
// NEW_FEATURE: BUILD_PROFILE !== "prod",

// Example: Toggle a feature based on user properties
// NEW_FEATURE: user?.isAlias,

export function getFeatureFlags() {
  return {
    ISOLATING_LEGACY_WEB_PAGES: true,
    FLEXIBLE_MD_FILL: false,
    PARTIAL_CANCEL: true,
    TIMESHEET_MISSING_BREAK_ACTION_SHEET: BUILD_PROFILE !== "prod",
  };
}
